var chunkToChildrenMap = {
	"1067": [
		5187,
		6773,
		7488
	],
	"1911": [
		5187,
		6773,
		7488
	],
	"3839": [
		3563,
		1220,
		1474,
		2624,
		6584,
		831,
		5660,
		2932,
		3692,
		9307,
		5549,
		2511,
		432,
		6535,
		1772,
		3133,
		1620,
		8378,
		1313,
		4140
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));